import classNames from 'classnames'
import React, { SFC } from 'react'

import { Button, isBlank } from '../../../shared'

import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { SortDirection } from '../models'

type Props = {
  tight?: boolean
  sortDirection?: SortDirection
  sortable?: boolean
  'data-test'?: string
  onSortChange?(): void
}

const TableHeadColumn: SFC<Props> = ({ children, tight = false, sortDirection, onSortChange, sortable, ...rest }) => {
  const className = classNames('th-sortable', {
    'tight-table-column': tight,
  })

  const iconType = isBlank(sortDirection)
    ? IconNames.DOUBLE_CARET_VERTICAL
    : sortDirection === 'asc'
      ? IconNames.CARET_UP
      : IconNames.CARET_DOWN

  return (
    <th className={className} {...rest}>
      {sortable && (
        <Button
          icon={<Icon icon={iconType} iconSize={Icon.SIZE_STANDARD} title={false} />}
          onClick={onSortChange}
          className="bp3-minimal"
        >
          <span>{children}</span>
        </Button>
      )}

      {!sortable && <span>{children}</span>}
    </th>
  )
}

export { TableHeadColumn }



// WEBPACK FOOTER //
// ./src/app/shared/smart-table/components/table-head-column.component.tsx